var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Header'),_c('Recorded'),_c('NumberOfCases'),_c('TimeLine'),_c('CourtCases'),_c('Statistics'),_c('Sector'),_c('Stages'),_c('PrivateSector'),_c('PublicSector'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }